import { Box, Flex, Image } from "@chakra-ui/react";
import type { DTO } from "@equidefi/shared/types/dto";
import { Heading, Text } from "@equidefi/ui";
import type React from "react";

import { CurrencyFormatter } from "@/constants/format";

interface InvestmentTitleCardProps {
  investment: DTO.Investment;
  issuer: DTO.Issuer | null | undefined;
  offering: DTO.Offering | null | undefined;
}

export const InvestmentTitleCard: React.FC<InvestmentTitleCardProps> = ({ investment, issuer, offering }) => (
  <Box bg="white" borderRadius={{ base: "10px", md: "12px" }} boxShadow="card" p={{ base: 4, md: 6 }}>
    <Flex align="center" gap="4">
      <Image
        src={issuer?.photo_url}
        alt={`${issuer?.name ?? "Issuer"} logo`}
        boxSize={{ base: "56px", md: "72px" }}
        borderRadius="12px"
        objectFit="contain"
        bg="#1a2434"
        p="2.5"
        flexShrink={0}
      />
      <Box minW="0">
        <Text m="0" color="gray.500" fontSize={{ base: "sm", md: "md" }}>
          Your investment in
        </Text>
        <Heading m="0" fontWeight="bold" color="#171c2c" fontSize={{ base: "xl", md: "2xl" }}>
          {offering?.name}
        </Heading>
        <Text m="0" fontWeight="semibold" color="#171c2c" fontSize={{ base: "md", md: "lg" }}>
          {CurrencyFormatter.format(investment.amount)}
        </Text>
      </Box>
    </Flex>
  </Box>
);

export default InvestmentTitleCard;
